module.exports = __webpack_public_path__ + "static/img/xiangyoujiantouIcon2.4f2cd3ed.svg";